"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));
var _formatArrayToValue = _interopRequireDefault(require("../../utils/formatArrayToValue"));
var _formatValueToArray = _interopRequireDefault(require("../../utils/formatValueToArray"));
var _Label = _interopRequireDefault(require("../Label"));
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _Slider2 = _interopRequireDefault(require("./Slider.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Slider = _ref => {
  let {
    defaultValue,
    identifier,
    label,
    loading = false,
    max,
    min,
    showAccordion = false,
    showSelectedValues = false,
    valueFormatter = 1,
    valuePrefix,
    onChange,
    onSubmit
  } = _ref;
  const [maxValue, setMaxValue] = (0, _react.useState)(100);
  const [minValue, setMinValue] = (0, _react.useState)(0);
  const [value, setValue] = (0, _react.useState)();
  const ref = (0, _react.useRef)(null);
  const css = (0, _Slider2.default)();
  (0, _react.useEffect)(() => {
    setMaxValue(max);
  }, [max]);
  (0, _react.useEffect)(() => {
    setMinValue(min);
  }, [min]);
  (0, _react.useEffect)(() => {
    setValue((0, _formatValueToArray.default)(defaultValue) ?? [minValue, maxValue]);
    if (!ref?.current) return;
    ref.current.value = defaultValue;
  }, [defaultValue, maxValue, minValue, ref]);
  const formattedMinValue = (0, _react.useMemo)(() => {
    return Math.floor(value?.[0] / valueFormatter);
  }, [value, valueFormatter]);
  const formattedMaxValue = (0, _react.useMemo)(() => {
    return Math.ceil(value?.[1] / valueFormatter);
  }, [value, valueFormatter]);
  if (loading) return /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    isAccordion: showAccordion
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, "mco-filter-item", {
      [css.itemAccordion]: showAccordion,
      "mco-filter-item__accordion": showAccordion
    })
  }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: showAccordion,
    wrapper: children => /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      classes: {
        root: (0, _clsx.default)(css.accordion, "mco-filter-item__accordion")
      }
    }, /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, {
      classes: {
        root: (0, _clsx.default)(css.accordionLabel, "mco-filter-item__accordion-label"),
        content: (0, _clsx.default)(css.accordionLabelContent, "mco-filter-item__accordion-label-content")
      },
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      label: label,
      showSelectedValues: showSelectedValues,
      values: `${(0, _formatArrayToValue.default)(value)} ${valuePrefix}`
    })), /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, {
      classes: {
        root: (0, _clsx.default)(css.accordionContent, "mco-filter-item__accordion-content")
      }
    }, children))
  }, !showAccordion && label && /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    label: label
  })), value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.values, "mco-filter-item__values")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.value
  }, formattedMinValue, valuePrefix ? ` ${valuePrefix}` : ``), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.value
  }, formattedMaxValue, valuePrefix ? ` ${valuePrefix}` : ``)), /*#__PURE__*/_react.default.createElement(_Slider.default, {
    classes: {
      root: (0, _clsx.default)(css.slider, "mco-filter-item__slider"),
      rail: css.sliderRail,
      thumb: css.sliderThumb,
      track: css.sliderTrack
    },
    max: maxValue,
    min: minValue,
    value: value,
    onChange: (event, newValue) => {
      if (onChange) onChange(newValue);
      setValue(newValue);
      ref.current.value = (0, _formatArrayToValue.default)(newValue);
    },
    onChangeCommitted: onSubmit
  }), /*#__PURE__*/_react.default.createElement("input", {
    name: identifier,
    ref: ref,
    type: "hidden"
  }))));
};
var _default = exports.default = Slider;